import { createReduxStore } from "src/store/redux_store";

const OrgSamlIdpStore = createReduxStore({ name: "orgSamlIdp" });

export { OrgSamlIdpStore };
